var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { Services } from "../services";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsServerSelection',
    props: {
        queryTrsServer: null,
        trsSelection: null
    },
    emits: ["onError", "onTrsSelection"],
    setup(__props, { emit }) {
        const props = __props;
        const loading = ref(true);
        const selection = ref(null);
        const trsServers = ref([]);
        const trsSelectionLookup = ref(null);
        const showDropdown = computed(() => {
            return trsServers.value.length > 1;
        });
        watch(props, () => {
            var _a;
            selection.value = (_a = props.trsSelection) !== null && _a !== void 0 ? _a : null;
        });
        const services = new Services();
        function configureTrsServers() {
            return __awaiter(this, void 0, void 0, function* () {
                const servers = yield services.getTrsServers();
                const queryTrsServer = props.queryTrsServer;
                trsServers.value = servers;
                if (queryTrsServer) {
                    for (const server of servers) {
                        if (server.id == queryTrsServer) {
                            trsSelectionLookup.value = server;
                            break;
                        }
                        if (possibleServeUrlsMatch(server.api_url, queryTrsServer)) {
                            trsSelectionLookup.value = server;
                            break;
                        }
                        if (possibleServeUrlsMatch(server.link_url, queryTrsServer)) {
                            trsSelectionLookup.value = server;
                            break;
                        }
                    }
                }
                if (trsSelectionLookup.value === null) {
                    if (queryTrsServer) {
                        emit("onError", "Failed to find requested TRS server " + queryTrsServer);
                    }
                    trsSelectionLookup.value = servers[0];
                }
                selection.value = trsSelectionLookup.value;
                loading.value = false;
                onTrsSelection(trsSelectionLookup.value);
            });
        }
        configureTrsServers();
        function onTrsSelection(newSelection) {
            selection.value = newSelection;
            emit("onTrsSelection", newSelection);
        }
        function possibleServeUrlsMatch(a, b) {
            // let http://trs_server.org/ match with https://trs_server.org for instance,
            // we'll only use the one configured on the backend for making actual calls, but
            // allow some robustness in matching it
            a = a.replace(/^https?:\/\//, "").replace(/\/$/, "");
            b = b.replace(/^https?:\/\//, "").replace(/\/$/, "");
            return a === b;
        }
        return { __sfc: true, props, emit, loading, selection, trsServers, trsSelectionLookup, showDropdown, services, configureTrsServers, onTrsSelection, possibleServeUrlsMatch };
    }
});
